var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7059 0.704102C10.3493 0.704102 0.333069 10.7203 0.333069 23.0769C0.333069 35.4336 10.3493 45.4541 22.7059 45.4541C35.0625 45.4541 45.0831 35.4379 45.0831 23.0769V0.704102H22.7059ZM36.7008 23.0769C36.7008 30.809 30.4337 37.0719 22.7059 37.0719C14.9781 37.0719 8.7153 30.809 8.7153 23.0769C8.7153 15.3448 14.9781 9.08633 22.7059 9.08633H36.7008V23.0769Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7435 23.0768C28.7435 26.4141 26.039 29.1143 22.7061 29.1143C19.3731 29.1143 16.6729 26.4141 16.6729 23.0768C16.6729 19.7395 19.3731 17.0437 22.7061 17.0437C26.039 17.0437 28.7435 19.7439 28.7435 23.0768Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/OpenIcon.3f16b9be399892010ff9a539bbd9e77e.svg";
export { ForwardRef as ReactComponent };